import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiPaginate, ApiPaginateResult } from '../apiservices/apipaginated';
import { APIService } from '../apiservices/apiservices';

@Injectable()

export class ServicosProvider {
  private header=APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) {
  }
  
  get(params?: any): Promise<{Item:any, erro:string}> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'servico';
      
      me.http.get(url,{headers:me.header, params})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          
          var datasuccess={
            'Item':jsonData,
            'erro':jsonData?.erro
          }

          resolve(datasuccess);
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }

  /**
   * Atualiza serviço
   * @param dadosJson json com os dados do serviço
   * @returns 
   */
  addupdate(dadosJson:any): Promise<{Item:any, erro:string}> {
  var me=this;
  this.header=APIService.getHeader();

  return new Promise((resolve, reject) => {

    var requestData=JSON.stringify(dadosJson);
    let url = APIService.API_URL + 'servico';
    me.http.post(url, requestData,{headers:me.header})
      .subscribe((result: any) => {
        
        var jsonData=result;

        if (jsonData.length!=0)
        {
          if (jsonData.status_ret!="NOK")
          {
              var datasuccess={
                'Item':jsonData,
                'erro':''
              }
              me.itemret=datasuccess;
          }
          else{
            //console.log(jsonData.erro);
            var errodatavazio={
              'Item':null,
              'erro':'Erro na atualização do serviço.'
            }
            me.itemret=errodatavazio;
          }
          
          resolve(me.itemret);
        }
        else{
          var errodatavazio1={
            'Item':null,
            'erro':'Não há consultas.'
          }
          me.itemret=errodatavazio1;
        }
      },
      (error) => {
        var msg="";
        if (error.status==401){
          msg=error.statusText;
        }
        else{
          msg=error.error;
        }
        let errojson =msg;

        var errochamada={
          'Item':null,
          'erro':errojson
        }
        me.itemret=errochamada;
        reject(me.itemret);
        
      });
  });
  }

  
  getPaginated(paginacao: ApiPaginate) : Promise<ApiPaginateResult> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'servico?operacao=page&' + paginacao.geraAPIUrl();

      me.http.get(url, {headers: this.header}).subscribe((result: ApiPaginateResult) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  deleteServicoDepartamento(idDepartamento: string, idServico: string){
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'servico';
      
      me.http.delete(url,{headers:me.header, params: {
        operacao: "departamento",
        idDepartamento: idDepartamento,
        idServico: idServico
      }})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na exclusão do servico.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Nenhum registro encontrado.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }

  deleteServicoArquivo(idArquivo: string, idServico: string): Promise<{Item:any, erro:string}> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'servico';
      
      me.http.delete(url,{headers:me.header, params: {
        operacao: "arquivos",
        idArquivo: idArquivo,
        idServico: idServico
      }})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na exclusão do servico.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Nenhum registro encontrado.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }

  getFilesByIds(ids: string[] | number[], idServico: string | number): Promise<any> {
    var me = this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'servico?operacao=arquivos&ids=' + ids.join(',') + '&idServico=' + idServico;

      me.http.get(url, {headers: this.header}).subscribe((result: ApiPaginateResult) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }
}
